import { render, staticRenderFns } from "./ChatsList.vue?vue&type=template&id=668214a4&scoped=true&"
import script from "./ChatsList.vue?vue&type=script&lang=js&"
export * from "./ChatsList.vue?vue&type=script&lang=js&"
import style0 from "./ChatsList.vue?vue&type=style&index=0&id=668214a4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "668214a4",
  null
  
)

export default component.exports